import customSelector from './custom_selector';
import sizeGuide from './size_guide';
import stickyActionBar from './sticky_addToCart';
import swatchSelector from './swatch_selector';
import thumbnailZoom from './thumbnail_zoom';
import playVideoInMobile from './play_video_in_mobile';
import giftCards from './gift_cards';
import backToTop from './back_to_top';
import volumeVariants from './volume_variants';

// run all related funcs here
const runFuncs = () => {
  backToTop();
  thumbnailZoom();
  playVideoInMobile();
  customSelector();
  sizeGuide();
  stickyActionBar();
  swatchSelector();
  giftCards();
  volumeVariants();
};

export default runFuncs;
